export function verifyIllegality(val, arr = ['', undefined, null]) {
    return arr.includes(val)
}